
((global) => {
  /**
  * Панель уведомлений.
  *
  * @class WebAccess.components.notifications.NotificationsPanel
  * @extends WA.CMP.SidePanel
  * @since 5.8.2.9000
  */
  class NotificationsPanel extends WA.CMP.SidePanel {
    constructor() {
      super();

      window.addEventListener('storage', e => {
        if (e.key === 'notifications') {
          const oldNotificationIds = JSON.parse(e.oldValue).map(ntf => {
            return ntf.id;
          }) || [];
          const currentNotifications = JSON.parse(e.newValue) || [];

          if (!currentNotifications.length) {
            let event = document.createEvent('CustomEvent');
            event.initCustomEvent('noNotifications', true, false, '');
            document.dispatchEvent(event);
          } else {
            const newNotifications = currentNotifications.filter(ntf => { return !(oldNotificationIds.includes(ntf.id)); });

            this.notifyNew(newNotifications);
          }

          // Контент должен перестраиваться только при открытой панели уведомлений.
          if ($('#NotificationsPanel').hasClass('active')) {
            this.render();
          }
        }
      });
    };

    /**
     * Отображает панель уведомлений.
	   * @function WebAccess.components.notifications.NotificationsPanel.render
     * */
    render() {
      let notificationsHtml = '';
      var storedNotifications = this.getStoredNotifications();
      storedNotifications.forEach(notification => {
        let ntf = new WA.CMP.NTF.Notification(notification);
        ntf.render();
        notificationsHtml += ntf.html;
      });

      let innerHtml = `<div id="ntfHeader">
          <div style="float: left; padding-top: 4px;">
            <span>${L('NOTIFICATIONS')}</span>
          </div>
          <div class="tool-button" title="${L('DELETE_ALL')}" onClick="document.notificationsPanel.deleteAllHandler();">
            <svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#trash-16"></use></svg>
          </div>
        </div>
        <div id="ntfList">${notificationsHtml}</div>`;
      this.html = `<div id="NotificationsPanel" class="sidepanel">${innerHtml}</div>`;
      let panelElement = $('#NotificationsPanel');
      if (panelElement.length) {
        panelElement.html(innerHtml);
      } else {
        let form = $('form');
        if (form) {
          form.prepend(this.html);
          $(document).click(e => { this.closePanel(e) });
        }
      }
      return this;
    };

    /**
     * Возвращает уведомления из локального хранилища браузера (localStorage).
	   * @function WebAccess.components.notifications.NotificationsPanel.getStoredNotifications
     * */
    getStoredNotifications() {
      return JSON.parse(localStorage.getItem('notifications')) || [];
    };

    /**
     * Удаляет уведомление из панели и локального хранилища браузера (localStorage).
	   * @function WebAccess.components.notifications.NotificationsPanel.deleteNtf
     * @param {any} idToDel Идентификатор удаляемого уведомления
     */
    deleteNtf(idToDel) {
      let storedNotifications = JSON.parse(localStorage.getItem('notifications'));
      if (storedNotifications.length) {
        storedNotifications = storedNotifications.filter(function (ntf) { return ntf.id !== idToDel; });
        localStorage.setItem('notifications', JSON.stringify(storedNotifications));
        this.render();
      }
    };

    /**
     * Удаляет все уведомления из панели и локального хранилища браузера (localStorage).
	   * @function WebAccess.components.notifications.NotificationsPanel.deleteAllHandler
     * */
    deleteAllHandler() {
      window.event.cancelBubble = true;
      event.stopPropagation();
      localStorage.setItem('notifications', '[]');
      this.render();
    };

    /**
     * Сообщает о получении новых уведомлений.
	   * @function WebAccess.components.notifications.NotificationsPanel.notifyNew
     * @param {Array<Notification>} notifications Новые уведомления
     */
    notifyNew(notifications) {
      if (notifications && notifications.length) {
        if (!($('#NotificationsPanel').hasClass('active'))) {
          let event = document.createEvent('CustomEvent');
          event.initCustomEvent('newNotification', true, false, '');
          document.dispatchEvent(event);

          const toast = new WA.CMP.NTF.Toast();
          toast.showMessage(notifications.map(ntf => { return `<strong>${ntf.title.escapeHtml()}</strong><br/>${ntf.text.escapeHtml()}`; }).join('<br/><br/>'), false, 10000);
        }
      }
    };

    /**
     * Помечает уведомление как прочитанное.
	   * @function WebAccess.components.notifications.NotificationsPanel.markRead
     * @param {string} id Идентификатор уведомления
     */
    markRead(id) {
      let storedNotifications = JSON.parse(localStorage.getItem('notifications'));
      localStorage.setItem('notifications', JSON.stringify(storedNotifications.map(item => {
        if (item.id === id) {
          item.new = false;
        }
        return item;
      })));
      this.render();
    };
  }

  global.NotificationsPanel = NotificationsPanel;
})(window.WebAccess.components.notifications);